import React from 'react';

function AvailabilityBadge(props) {
    return (
        <div>
            
        </div>
    );
}

export default AvailabilityBadge;